import { giphyLightGrey } from '@giphy/js-brand'
import { IUser } from '@giphy/js-types'
import { Title as BrandTitle } from '@giphy/react-giphy-brand'
import React, { useContext } from 'react'
import SearchOptionsContext from 'shared/components/context/search-options'
import { bodyFont } from 'shared/css/fonts'
import { desktop, mobile } from 'shared/util/media-query'
import styled from 'styled-components'

// copied from mainTitleMobile in typography.css
// tyring to use brand...
// feel like this should maybe shared across mobile?
const Title = styled(BrandTitle)`
    ${mobile.css`
        font-family: ${bodyFont};
        font-weight: bold;
    `}
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    ${desktop.css`
        font-size: 36px;
    `}
`

const Container = styled.div`
    width: 50%;
    text-align: left;
    align-self: center;
    flex-grow: 1;
    hyphens: auto;
    overflow: hidden;
    ${mobile.css`
        margin-top: 14px;
    `}
`

const NumberDisplay = styled.span`
    color: ${giphyLightGrey};
    padding-left: 0.4em;
    text-transform: none;
    font-size: 14px;
    white-space: pre;
    font-family: interface;
    font-weight: 700;
    &:before {
        content: attr(data-gif-count);
    }
`

type Props = {
    displayTerm?: string
    totalCount?: number
    user: IUser
}
export const SearchResultsDisplay = ({ displayTerm, totalCount, user: { username } }: Props) => {
    const { type } = useContext(SearchOptionsContext)
    const getTitle = (displayTerm?: string, username?: string) => {
        if (displayTerm) {
            return displayTerm
        } else if (username) {
            return `All the ${username} GIFs`
        } else {
            return ''
        }
    }
    return (
        <Container>
            <Title as="h1">
                {getTitle(displayTerm, username)}
                {typeof totalCount === 'number' && (
                    <NumberDisplay data-gif-count={totalCount.toLocaleString()}>
                        {` ${type === 'stickers' ? 'Sticker' : 'GIF'}${totalCount === 1 ? '' : 's'}`}
                    </NumberDisplay>
                )}
            </Title>
        </Container>
    )
}
export default SearchResultsDisplay
